import React from "react";
import {
    BrowserRouter,
    Route,
    RouteComponentProps,
    HashRouter,
    Redirect,
    Switch,
} from "react-router-dom";
import { connect } from "react-redux";
import { Snackbar } from "material-ui";

// Redux stuff
import { ReduxState, ReduxDispatch } from "./ducks/reducers";
import { ShowDrawer, ShowFeedback } from "./ducks/common";
import { hideSnackbarAction } from "./ducks/snackbar";
import { fetchProfileData } from "./ducks/profile";

// Components
import AppBar from "./components/AppBar/AppBar";
import Drawer from "./components/Drawer/Drawer";
import BottomBar from "./components/BottomBar/BottomBar";
import PrivateRoute from "./components/PrivateRoute";

// Available pages
import PortfolioPage from "./views/portfolio/PortfolioPage";
import LoginPage from "./views/login/LoginPage";
import RegisterPage from "./views/register/RegisterPage";
import AccountPage from "./views/account/AccountPage";
import WithdrawalRequestPage from "./views/account/WithdrawalRequestPage";
import WithdrawalRequestSentPage from "./views/account/WithdrawalRequestSentPage";
import DepositPage from "./views/account/DepositPage";
import NewsFeedPage from "./views/newsfeed/NewsFeedPage";
import NewsFeedItemPage from "./views/newsfeed/NewsFeedItemPage";
import LoanEditPage from "./views/loan/LoanEditPage";
import LoanEditFormSentPage from "./views/loan/LoanEditFormSentPage";
import TupasPage from "./views/tupas/TupasPage";
import TupasSuccessPage from "./views/tupas/TupasSuccessPage";
import TupasErrorPage from "./views/tupas/TupasErrorPage";
import ProfilePage from "./views/profile/ProfilePage";

import ThreadsPage from "./views/messages/ThreadsPage";
import ThreadPage from "./views/messages/threadpage/ThreadPage";
import TupasLoginPage from "./views/login/TupasLogin";
import CreateLoginPage from "./views/profile/CreateLoginPage";
import ChangePasswordPage from "./views/profile/ChangePasswordPage";
import EditProfilePage from "./views/profile/EditProfilePage";
import LoansPage from "./views/loan/LoansPage";
import AccountsPage from "./views/account/AccountsPage";
import {
    checkShouldPromptFeedback,
    logout,
    updateFeedbackDate,
} from "ducks/user";
import AboutPage from "views/about/AboutPage";
import TermsPage from "views/about/TermsPage";
import AccessibilityPage from "views/about/AccessibilityPage";
import NewThreadPage from "views/messages/NewThreadPage";
import CreditCardDetailsPage from "views/creditcard/CreditCardDetailsPage";
import CreditCardsPage from "views/creditcard/CreditCardsPage";
import EIdentifyPage from "views/eidentify/EIdentifyPage";
import EIdentifySuccess from "views/eidentify/EIdentifySuccess";
import EIdentifySuccessPage from "views/eidentify/EIdentifySuccess";
import EIdentifyErrorPage from "views/eidentify/EIdentifyError";
import { getAccessibilitySetting, setAccessibilitySetting } from "util/utils";
import DocumentationsPage from "views/documentation/DocumentationsPage";
import LoanInstalmentsPage from "views/loan/LoanInstalmentsPage";
import FeedbackDialog from "components/Dialog/FeedbackDialog";
import { FeedbackType } from "types/enums";
import { checkShouldPromptFeedbackFeature } from "ducks/feedbackFeature";
import FeedbackFeatureDialog from "components/Dialog/FeedbackFeatureDialog";

interface IAppProps {}

interface IAppState {}

interface IAppReduxProps {
    appHeader: string;
    showAppLogo: boolean;
    showDrawer: boolean;
    showFeedback: boolean;
    showSnackbar: boolean;
    snackbarText: string;
    showBackButton: boolean;
    showActionButton: boolean;
    isLoggedIn: boolean;
    showBottomBar: boolean;
    userName: string;
    PromptFeedback: boolean;
    featureFeedbackType: FeedbackType | undefined;
    showFeatureFeedback: boolean;
}

interface IAppDispatchProps {
    toggleDrawer: (show: boolean) => void;
    toggleFeedback: (show: boolean) => void;
    hideSnackbar: () => void;
    logout: () => void;
    fetchProfile: () => void;
    checkShouldPromptFeedback: (
        toggleFeedback: (show: boolean) => void
    ) => void;
    checkShouldPromptFeedbackFeature: () => void;
}

type AppProps = IAppProps & IAppReduxProps & IAppDispatchProps;

class App extends React.Component<AppProps, IAppState> {
    public componentDidMount() {
        this.initAccessibilitySettings();
    }

    componentWillReceiveProps(nextProps: AppProps) {
        // if (this.props.isLoggedIn) {
        //     this.props.fetchProfile();
        // }
        if (!this.props.isLoggedIn && nextProps.isLoggedIn) {
            this.props.checkShouldPromptFeedback(this.props.toggleFeedback);
            this.props.checkShouldPromptFeedbackFeature();
            this.props.fetchProfile();
        }
    }

    getRouter() {
        let Router;
        try {
            if (cordova) {
                Router = HashRouter;
            } else {
                Router = BrowserRouter;
            }
        } catch (e) {
            // logger.info("No Cordova");
            Router = BrowserRouter;
        }
        // Implement cordova router support here
        return Router;
    }

    render() {
        const Router = this.getRouter();
        return (
            <Router>
                <div id="hypo-bongari">
                    <div className="background" />
                    {(this.props.isLoggedIn || this.props.showBackButton) && (
                        <AppBar
                            showLogo={this.props.showAppLogo}
                            header={this.props.appHeader}
                            toggleDrawer={this.props.toggleDrawer}
                            showBackButton={this.props.showBackButton}
                            showActionButton={this.props.showActionButton}
                            showDrawer={this.props.isLoggedIn}
                        />
                    )}
                    {this.props.isLoggedIn && (
                        <Drawer
                            open={this.props.showDrawer}
                            drawerToggle={this.props.toggleDrawer}
                            feedbackToggle={this.props.toggleFeedback}
                            logout={this.props.logout}
                            userName={this.props.userName}
                        />
                    )}
                    {this.props.isLoggedIn && (
                        <FeedbackDialog
                            open={this.props.showFeedback}
                            ToggleShowFeedback={this.props.toggleFeedback}
                        />
                    )}
                    {this.props.isLoggedIn &&
                        this.props.showFeatureFeedback &&
                        // Don't override general feedback dialog
                        !this.props.showFeedback &&
                        // Enum starts from 1
                        this.props.featureFeedbackType && (
                            <FeedbackFeatureDialog
                                open={this.props.showFeatureFeedback}
                                feature={this.props.featureFeedbackType}
                            />
                        )}
                    <Snackbar
                        open={this.props.showSnackbar}
                        onClose={this.props.hideSnackbar}
                        autoHideDuration={5000}
                        SnackbarContentProps={{
                            "aria-describedby": "message-id",
                        }}
                        message={
                            <span id="message-id">
                                {this.props.snackbarText}
                            </span>
                        }
                    />

                    <div
                        style={{
                            paddingBottom: this.props.showBottomBar ? 56 : 0,
                        }}
                        role="main"
                    >
                        <Switch>
                            <Route exact path="/login" component={LoginPage} />

                            <Route
                                exact
                                path="/login/:verificationHash"
                                component={TupasLoginPage}
                            />

                            <Route
                                exact
                                path="/register/:verificationHash?"
                                component={RegisterPage}
                            />

                            <Route
                                exact
                                path="/eidentify/success"
                                component={EIdentifySuccessPage}
                            />
                            <Route
                                exact
                                path="/eidentify/error"
                                component={EIdentifyErrorPage}
                            />
                            <Route
                                exact
                                path="/eidentify/:requestType?"
                                component={EIdentifyPage}
                            />

                            {/* TUPAS */}
                            <Route
                                exact
                                path="/tupas/verification/:requestType?/:relatedId?"
                                component={TupasPage}
                            />
                            <Route
                                exact
                                path="/tupas/error"
                                component={TupasErrorPage}
                            />
                            <Route
                                exact
                                path="/tupas/cancel"
                                component={TupasErrorPage}
                            />
                            <Route
                                exact
                                path="/tupas/rejection"
                                component={TupasErrorPage}
                            />
                            <Route
                                exact
                                path="/tupas/success"
                                component={TupasSuccessPage}
                            />

                            <Route
                                exact
                                path="/accessibility"
                                component={AccessibilityPage}
                            />
                            <Route exact path="/about" component={AboutPage} />
                            <Route exact path="/terms" component={TermsPage} />

                            <PrivateRoute
                                exact
                                path="/"
                                component={PortfolioPage}
                                isAllowed={this.props.isLoggedIn}
                            />
                            {/* Messages */}
                            <PrivateRoute
                                exact
                                path="/messages"
                                component={ThreadsPage}
                                isAllowed={this.props.isLoggedIn}
                            />

                            <PrivateRoute
                                exact
                                path="/messages/new-thread"
                                component={NewThreadPage}
                                isAllowed={this.props.isLoggedIn}
                            />

                            <PrivateRoute
                                exact
                                path="/messages/:threadId"
                                component={ThreadPage}
                                isAllowed={this.props.isLoggedIn}
                            />

                            {/* News feed */}
                            <PrivateRoute
                                exact
                                path="/newsfeed"
                                component={NewsFeedPage}
                                isAllowed={this.props.isLoggedIn}
                            />

                            <PrivateRoute
                                exact
                                path="/newsfeed/:itemId"
                                component={NewsFeedItemPage}
                                isAllowed={this.props.isLoggedIn}
                            />

                            {/* Loan */}
                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/loan/:id?"
                                component={LoansPage}
                            />

                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/loan/:id/edit"
                                component={LoanEditPage}
                            />

                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/loan/edit/requestsent"
                                component={LoanEditFormSentPage}
                            />

                            {/* Account */}
                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/account/:id?"
                                component={AccountsPage}
                            />

                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/account/request/withdrawal"
                                component={WithdrawalRequestPage}
                            />
                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/account/request/withdrawalsent"
                                component={WithdrawalRequestSentPage}
                            />
                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/account/:id/deposit"
                                component={DepositPage}
                            />

                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/profile"
                                component={ProfilePage}
                            />
                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/profile/edit"
                                component={EditProfilePage}
                            />
                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/profile/createlogin/:verificationHash?"
                                component={CreateLoginPage}
                            />
                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/profile/changepassword/:verificationHash?"
                                component={ChangePasswordPage}
                            />
                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/creditcards/:id?"
                                component={CreditCardsPage}
                            />
                            <PrivateRoute
                                isAllowed={this.props.isLoggedIn}
                                exact
                                path="/documentations"
                                component={DocumentationsPage}
                            />
                            <Route
                                exact
                                path=""
                                component={
                                    this.props.isLoggedIn
                                        ? PortfolioPage
                                        : LoginPage
                                }
                            />
                        </Switch>
                    </div>
                    {this.props.isLoggedIn && this.props.showBottomBar && (
                        <BottomBar />
                    )}
                </div>
            </Router>
        );
    }

    private readonly initAccessibilitySettings = () => {
        const setting = getAccessibilitySetting();
        const isEnabled = setting === "true";
        setAccessibilitySetting(isEnabled);
    };
}

const mapStateToProps = (state: ReduxState): IAppReduxProps => {
    return {
        appHeader: state.common.header,
        showAppLogo: state.common.showLogo,
        showDrawer: state.common.showDrawer,
        showFeedback: state.common.showFeedback,
        showSnackbar: state.snackbar.show,
        snackbarText: state.snackbar.text,
        showBackButton: state.common.showBackButton,
        showActionButton: state.actionbutton.showActionButton,
        isLoggedIn: state.user.isLoggedIn,
        showBottomBar: state.common.showBottomBar,
        userName: `${state.profile.firstName || ""} ${
            state.profile.lastName || ""
        }`,
        PromptFeedback: state.user.promptFeedback,
        showFeatureFeedback: state.feedbackFeatures.shouldPrompt,
        featureFeedbackType: state.feedbackFeatures.feature,
    };
};

const mapDispatchToProps = (dispatch: ReduxDispatch): IAppDispatchProps => {
    return {
        toggleDrawer: async (show: boolean) => {
            await dispatch(ShowDrawer(show));
        },
        toggleFeedback: async (show: boolean) => {
            await dispatch(updateFeedbackDate());
            await dispatch(ShowFeedback(show));
        },
        hideSnackbar: async () => {
            await dispatch(hideSnackbarAction());
        },
        logout: async () => {
            await dispatch(logout());
        },
        fetchProfile: async () => {
            await dispatch(fetchProfileData());
        },
        checkShouldPromptFeedback: async (
            toggleFeedback: (show: boolean) => void
        ) => {
            let result = await dispatch(checkShouldPromptFeedback());
            if (result) {
                toggleFeedback(true);
            }
        },
        checkShouldPromptFeedbackFeature: () => {
            dispatch(checkShouldPromptFeedbackFeature());
        },
    };
};

export default connect<IAppReduxProps, IAppDispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.tsx